<template>
  <mc-button 
    v-if="showUserflow" 
    icon="icon-filled-circle-question" 
    :class="['nav-menu-plugin-button', 'userflow-menu-button']" 
    @click="handleUserflowButtonClick"
  >
    <span class="nav-menu-plugin-button-text">Help</span>
  </mc-button>
 </template>

<script setup lang="ts">
import { computed } from 'vue';
import userflow from 'userflow.js';
import McButton from '@/components/ui/McButton.vue';
import { useUserProfileStore } from '@/store/userProfileStore';

const userProfileStore = useUserProfileStore();
const showUserflow = computed(() => userProfileStore.showUserflow);

const handleUserflowButtonClick = () => userflow.toggleResourceCenter();
</script>

<style scoped lang="scss">
.userflow-menu-button {
  --button-padding: 8px 11.5px;
}
</style>